import React from 'react'

const FooterList = ({ children, classes = '' }) => {
	return <ul className={`footer__list ${classes}`}>{children}</ul>
}

export default FooterList
